// removed by extract-text-webpack-plugin
module.exports = {"app":"AudioPlayerApp__app___qgWXb"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AudioPlayerApp.scss
 ** module id = 648
 ** module chunks = 0
 **/